function calculateTransformation(fixedPoints, movingPoints) {
    const vector1 = {
        start: { x: fixedPoints[0][0], y: fixedPoints[0][1] },
        end: { x: fixedPoints[1][0], y: fixedPoints[1][1] },
    };

    const vector2 = {
        start: { x: movingPoints[0][0], y: movingPoints[0][1] },
        end: { x: movingPoints[1][0], y: movingPoints[1][1] },
    };

    const lengthFixed = Math.sqrt(Math.pow(vector1.end.x - vector1.start.x, 2) + Math.pow(vector1.end.y - vector1.start.y, 2));
    const lengthMoving = Math.sqrt(Math.pow(vector2.end.x - vector2.start.x, 2) + Math.pow(vector2.end.y - vector2.start.y, 2));

    const scale = lengthMoving / lengthFixed;

    const angle1 = Math.atan2(vector1.end.y - vector1.start.y, vector1.end.x - vector1.start.x);
    const angle2 = Math.atan2(vector2.end.y - vector2.start.y, vector2.end.x - vector2.start.x);

    const angle = angle2 - angle1;

    let tmpX = vector1.start.x * scale;
    let tmpY = vector1.start.y * scale;

    let rotX = Math.cos(angle) * tmpX - Math.sin(angle) * tmpY;
    let rotY = Math.sin(angle) * tmpX + Math.cos(angle) * tmpY;

    const translation = {
        x: vector2.start.x - rotX,
        y: vector2.start.y - rotY,
    };

    let scaleX = (vector1.end.x - vector1.start.x) * (vector2.end.x - vector2.start.x);
    let flipX = scaleX < 0;

    let scaleY = (vector1.end.y - vector1.start.y) * (vector2.end.y - vector2.start.y);
    let flipY = scaleY < 0;

    return {
        translation: translation,
        rotation: angle,
        scale: scale,
        flip: [flipX, flipY],
    };
}

function changeOrigin(coordinates, origin, flip) {
    let x = flip.horizontally ? -1 : 1;
    let y = flip.vertically ? -1 : 1;
    for (let i = 0; i < coordinates.length; i++) {
        coordinates[i][0] = (origin.center[0] - coordinates[i][0]) * x;
        coordinates[i][1] = (origin.center[1] - coordinates[i][1]) * y;
    }
}

function getReturnedTransformation(otherViewport, thisAlignmentPoints, otherAlignmentPoints) {
    let otherPadding = otherViewport.getViewportPadding();
    const otherVector = {
        start: { x: otherAlignmentPoints[0][0], y: otherAlignmentPoints[0][1] },
        end: { x: otherAlignmentPoints[1][0], y: otherAlignmentPoints[1][1] },
    };

    if (otherPadding.x > 0) {
        otherVector.start.x = otherPadding.boxSize - otherVector.start.x;
        otherVector.end.x = otherPadding.boxSize - otherVector.end.x;
    }

    if (otherPadding.y > 0) {
        otherVector.start.y = otherPadding.boxSize - otherVector.start.y;
        otherVector.end.y = otherPadding.boxSize - otherVector.end.y;
    }

    let thisPadding = this.getViewportPadding();
    const thisVector = {
        start: { x: thisAlignmentPoints[0][0], y: thisAlignmentPoints[0][1] },
        end: { x: thisAlignmentPoints[1][0], y: thisAlignmentPoints[1][1] },
    };

    if (thisPadding.x > 0) {
        thisVector.start.x = thisPadding.boxSize - thisVector.start.x;
        thisVector.end.x = thisPadding.boxSize - thisVector.end.x;
    }

    if (thisPadding.y > 0) {
        thisVector.start.y = thisPadding.boxSize - thisVector.start.y;
        thisVector.end.y = thisPadding.boxSize - thisVector.end.y;
    }

    const otherLength = Math.sqrt(Math.pow(otherVector.end.x - otherVector.start.x, 2) + Math.pow(otherVector.end.y - otherVector.start.y, 2));
    const thisLength = Math.sqrt(Math.pow(thisVector.end.x - thisVector.start.x, 2) + Math.pow(thisVector.end.y - thisVector.start.y, 2));

    const scale = thisLength / otherLength;

    let otherVectorX = otherVector.start.x * scale;
    let otherVectorY = otherVector.start.y * scale;

    let thisVectorX = thisVector.start.x;
    let thisVectorY = thisVector.start.y;

    const otherAngle = Math.atan2(otherVector.end.y - otherVector.start.y, otherVector.end.x - otherVector.start.x);
    const thisAngle = Math.atan2(thisVector.end.y - thisVector.start.y, thisVector.end.x - thisVector.start.x);

    const angle = thisAngle - otherAngle;

    let tmpX = otherVectorX - (otherViewport.imageInfo.Width * scale) / 2;
    let tmpY = otherVectorY - (otherViewport.imageInfo.Height * scale) / 2;

    let rotatedOtherVectorX = Math.cos(angle) * tmpX - Math.sin(angle) * tmpY;
    let rotatedOtherVectorY = Math.sin(angle) * tmpX + Math.cos(angle) * tmpY;

    otherVectorX = rotatedOtherVectorX + this.imageInfo.Width / 2;
    otherVectorY = rotatedOtherVectorY + this.imageInfo.Height / 2;

    let returnedTransformation = {
        translation: {
            x: thisVectorX - otherVectorX,
            y: thisVectorY - otherVectorY,
        },
        rotation: (angle * 180) / Math.PI,
        scale: scale,
        flip: [false, false],
    };

    return returnedTransformation;
}

export function align(otherViewport, thisAlignmentPoints, otherAlignmentPoints) {
    const returnedTransformation = getReturnedTransformation.call(this, otherViewport, thisAlignmentPoints, otherAlignmentPoints);
    changeOrigin(otherAlignmentPoints, otherViewport.getPosition(), otherViewport.getFlip());
    changeOrigin(thisAlignmentPoints, this.getPosition(), this.getFlip());

    const trans = calculateTransformation(otherAlignmentPoints, thisAlignmentPoints);

    const flip1 = otherViewport.getFlip();
    const flip2 = this.getFlip();

    let rotation = otherViewport.getPosition().rotation + trans.rotation;
    if (flip1.horizontally !== flip2.horizontally || flip1.vertically !== flip2.vertically) {
        rotation *= -1;
    }

    trans.scale = otherViewport.getPosition().resolution * trans.scale;
    trans.rotation = rotation;
    trans.flip = [flip1.horizontally, flip1.vertically];

    applyTransformation.call(this, trans);

    return returnedTransformation;
}

export function applyTransformation(transformation) {
    let currentPosition = this.getPosition();

    currentPosition.resolution = transformation.scale;
    delete currentPosition.zoom;

    currentPosition.center[0] -= transformation.translation.x;
    currentPosition.center[1] -= transformation.translation.y;
    currentPosition.rotation = transformation.rotation;
    this.setPosition(currentPosition, true);

    this.setFlip(transformation.flip[0], transformation.flip[1]);
}
